import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
//import './Aa1HomePageStyle.css';

function Aa1TermsConditionPage() {

  const location = useLocation();
  const [language, setLanguage] = useState('AR');
  const [isGradient, setIsGradient] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');
    if(langParam)
    {
      setLanguage(langParam);
    }
  }, [location.search]);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)'
      : 'linear-gradient(to left, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)',
  };

  return (
    <div className="Aa1">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/kid-security-logo-en.avif'/></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/download-icon.avif'/></div>
          </div>
          <div id='terms' className='form-content-middle'>
            {language === 'AR' ? 
              <ul className='arabic'>
                <li>امان الأطفال هي خدمة اشتراك متوفرة لعملاء شركة الاتصالات السعودية مقابل ١ ريال لعملاء مسبق الدفع تتجدد يومي وبمقابل ٣٤.٥ ريال لعملاء المفوتر تتجدد شهري (شامل قيمة الضريبة المضافة)</li>
                <li>ولإلغاء الاشتراك الرجاء ارسال غ ١ الى 802460</li>
                <li>تم تحصيل مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن الرصيد</li>
                <li>لمشتركين موبايلي سعر الخدمة 1.51 ريال يوميا مع تجربة مجانية ليوم واحد عند اشتراكك اول مره (شامل قيمة الضريبة المضافة)</li>
                <li>تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصيد</li>
                <li>ولإلغاء الاشتراك أرسل غ ٥٨ إلى 607110</li>
              </ul>
              : 
              <ul className='english'>
                <li>Kid Security is a subscription service available for STC users that costs 1 Riyal renewed daily for prepaid subscribers and costs 34.5 Riyals renewed monthly for postpaid subscribers (VAT Included)</li>
                <li> To unsubscribe send U 1 to 802460, VAT Tax was already paid with a refill card for prepaid subscribers.</li>
                <li>For Mobily Subscribers the service price is 1.15 Riyal daily with a 1-day free trial for the first subscription(VAT Included).</li>
                <li>VAT Tax was already paid with a refill card for prepaid subscribers.</li>
                <li>and to unsubscribe send U 58 to 607110</li>
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aa1TermsConditionPage;